(function () {
  var BAR_W = 3;
  var BAR_GAP = 2;
  var BAR_RADIUS = 1.5;
  // Espelha $colors.warm / $colors.warm-light em sass/utils/colors.scss — manter em sincronia
  var PLAYED_COLOR = '#c4ab8a';
  var UNPLAYED_COLOR = '#e8ddd0';
  var audioCtx = null;

  function getAudioContext() {
    if (!audioCtx) {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    }
    return audioCtx;
  }

  function fmt(t) {
    if (!isFinite(t)) return '0:00';
    var m = Math.floor(t / 60);
    var s = Math.floor(t % 60).toString().padStart(2, '0');
    return m + ':' + s;
  }

  function extractPeaks(buffer, count) {
    var chan = buffer.getChannelData(0);
    var step = Math.floor(chan.length / count);
    var peaks = [];
    for (var i = 0; i < count; i++) {
      var start = i * step;
      var end = Math.min(start + step, chan.length);
      var max = 0;
      for (var j = start; j < end; j++) {
        var abs = Math.abs(chan[j]);
        if (abs > max) max = abs;
      }
      peaks.push(max);
    }
    var globalMax = Math.max.apply(null, peaks) || 1;
    for (var k = 0; k < peaks.length; k++) {
      peaks[k] = peaks[k] / globalMax;
    }
    return peaks;
  }

  function drawWaveform(canvas, peaks, progress) {
    var dpr = window.devicePixelRatio || 1;
    var rect = canvas.getBoundingClientRect();
    var w = rect.width;
    var h = rect.height;

    if (canvas.width !== Math.round(w * dpr) || canvas.height !== Math.round(h * dpr)) {
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
    }

    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var totalBarWidth = BAR_W + BAR_GAP;
    var barCount = peaks.length;
    var totalWidth = barCount * totalBarWidth - BAR_GAP;
    var offsetX = (w - totalWidth) / 2;
    var minH = 3;
    var maxH = h * 0.9;
    var centerY = h / 2;
    var progressX = offsetX + progress * totalWidth;

    for (var i = 0; i < barCount; i++) {
      var x = offsetX + i * totalBarWidth;
      var barH = minH + peaks[i] * (maxH - minH);
      var y = centerY - barH / 2;

      ctx.fillStyle = (x + BAR_W) <= progressX ? PLAYED_COLOR : UNPLAYED_COLOR;
      ctx.beginPath();
      ctx.roundRect(x, y, BAR_W, barH, BAR_RADIUS);
      ctx.fill();
    }
  }

  function initPlayer(root) {
    var audio = root.querySelector('audio');
    var btn = root.querySelector('.ap-play');
    var canvas = root.querySelector('.ap-waveform');
    var curEl = root.querySelector('.ap-current');
    var durEl = root.querySelector('.ap-duration');
    var peaks = null;
    var rafId = null;
    var decoded = false;

    function barCount() {
      var rect = canvas.getBoundingClientRect();
      return Math.floor(rect.width / (BAR_W + BAR_GAP));
    }

    function drawPlaceholder() {
      var count = barCount();
      var placeholder = [];
      for (var i = 0; i < count; i++) {
        placeholder.push(0.15 + Math.random() * 0.3);
      }
      drawWaveform(canvas, placeholder, 0);
    }

    drawPlaceholder();

    function decodeAndDraw() {
      if (decoded) return;
      decoded = true;
      var src = audio.src || audio.querySelector('source').src;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', src, true);
      xhr.responseType = 'arraybuffer';
      xhr.onload = function () {
        getAudioContext().decodeAudioData(xhr.response, function (buffer) {
          peaks = extractPeaks(buffer, barCount());
          var progress = audio.duration ? audio.currentTime / audio.duration : 0;
          drawWaveform(canvas, peaks, progress);
        });
      };
      xhr.send();
    }

    audio.addEventListener('loadedmetadata', function () {
      durEl.textContent = fmt(audio.duration);
      decodeAndDraw();
    });

    if (audio.readyState >= 1) {
      durEl.textContent = fmt(audio.duration);
      decodeAndDraw();
    }

    function renderLoop() {
      if (!peaks) return;
      var progress = audio.duration ? audio.currentTime / audio.duration : 0;
      drawWaveform(canvas, peaks, progress);
      curEl.textContent = fmt(audio.currentTime);
      if (!audio.paused) {
        rafId = requestAnimationFrame(renderLoop);
      }
    }

    btn.addEventListener('click', function () {
      if (audio.paused) {
        audio.play();
      } else {
        audio.pause();
      }
    });

    audio.addEventListener('play', function () {
      allPlayers.forEach(function (p) {
        if (p !== root) {
          var a = p.querySelector('audio');
          if (!a.paused) a.pause();
        }
      });
      btn.dataset.state = 'playing';
      btn.setAttribute('aria-label', 'Pausar');
      renderLoop();
    });

    audio.addEventListener('pause', function () {
      btn.dataset.state = 'paused';
      btn.setAttribute('aria-label', 'Reproduzir');
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      if (peaks) {
        var progress = audio.duration ? audio.currentTime / audio.duration : 0;
        drawWaveform(canvas, peaks, progress);
      }
    });

    audio.addEventListener('ended', function () {
      audio.currentTime = 0;
      audio.pause();
      if (peaks) drawWaveform(canvas, peaks, 0);
    });

    canvas.addEventListener('click', function (e) {
      if (!peaks || !audio.duration) return;
      var rect = canvas.getBoundingClientRect();
      var totalWidth = peaks.length * (BAR_W + BAR_GAP) - BAR_GAP;
      var offsetX = (rect.width - totalWidth) / 2;
      var clickX = e.clientX - rect.left - offsetX;
      var pct = Math.max(0, Math.min(1, clickX / totalWidth));
      audio.currentTime = pct * audio.duration;
      curEl.textContent = fmt(audio.currentTime);
      if (peaks) drawWaveform(canvas, peaks, pct);
    });

    root.addEventListener('keydown', function (e) {
      var k = e.key.toLowerCase();
      if (k === ' ') {
        e.preventDefault();
        btn.click();
      }
      if (k === 'arrowright') {
        audio.currentTime = Math.min(audio.duration || 0, audio.currentTime + 5);
      }
      if (k === 'arrowleft') {
        audio.currentTime = Math.max(0, audio.currentTime - 5);
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (peaks) {
          var src = audio.src || audio.querySelector('source').src;
          var xhr = new XMLHttpRequest();
          xhr.open('GET', src, true);
          xhr.responseType = 'arraybuffer';
          xhr.onload = function () {
            getAudioContext().decodeAudioData(xhr.response, function (buffer) {
              peaks = extractPeaks(buffer, barCount());
              var progress = audio.duration ? audio.currentTime / audio.duration : 0;
              drawWaveform(canvas, peaks, progress);
            });
          };
          xhr.send();
        } else {
          drawPlaceholder();
        }
      }, 200);
    });
  }

  var allPlayers = Array.from(document.querySelectorAll('.audio-player'));
  allPlayers.forEach(initPlayer);
})();
